import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import { ASC } from "const"
import { CcRequirement } from "server/models"
import { OrderType } from "client/utils"
import {
    StoreType,
    CcRequirementObjectProps,
    SortCcRequirement,
    DeleteCcRequirementParentChild,
    setCcRequirementParentChild,
    setAssignedCcRequirementParents,
    addModal,
} from "client/store"
import {
    PageContent,
    Table,
    SortRows,
    DeleteRow,
    Button,
} from "client/components"

import Columns from "./columns"
import NotAssignedParents from "../notAssigned/parents"
import { RequirementParentChildContentWrapper } from "../styled"

const Parents = ({
    requirement,
    editAccess,
}: CcRequirementObjectProps) => {
    const requirementList = useSelector((state: StoreType) => state.ccRequirement.requirementList)
    const requirementParentChild = useSelector((state: StoreType) => state.ccRequirement.requirementParentChild)
    const assignedParents = useSelector((state: StoreType) => state.ccRequirement.assigned.parents)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [requirementIds, setRequirementIds] = useState<number[]>([])
    const [sortColumn, setSortColumn] = useState<keyof CcRequirement>("name")
    const [sortOrder, setSortOrder] = useState<OrderType>(ASC)

    useEffect(() => {
        const sortedRequirements = SortCcRequirement(Object.values(requirementList), sortColumn, sortOrder, {})
        const assignedIds = assignedParents[requirement.id] || []

        const sortedIds: number[] = []
        sortedRequirements.forEach((row) => {
            if (assignedIds.includes(row.id)) sortedIds.push(row.id)
        })
        setRequirementIds(sortedIds)
    }, [requirementList, assignedParents, sortColumn, sortOrder])

    const onSort: SortRows = (column: keyof CcRequirement, order) => {
        setSortColumn(column)
        setSortOrder(order)
    }

    const onDelete: DeleteRow = (parent: CcRequirement, callback) => {
        DeleteCcRequirementParentChild(parent.id, requirement.id).then((removedRows) => {
            const success = removedRows === 1
            callback(success, () => {
                const parentChildFiltered = requirementParentChild.filter((row) => (
                    !(row.parentId === parent.id && row.childId === requirement.id)
                ))
                const parentIdsFiltered = assignedParents[requirement.id].filter((id) => id !== parent.id)

                dispatch(setCcRequirementParentChild(parentChildFiltered))
                dispatch(setAssignedCcRequirementParents(requirement.id, parentIdsFiltered))
            })
        })
    }

    const columns = Columns(editAccess)
    return (
        <RequirementParentChildContentWrapper>
            <PageContent>
                <Table
                    title={lang.parents}
                    columns={columns}
                    dataList={requirementList}
                    dataIds={requirementIds}
                    sortColumn={sortColumn}
                    sortOrder={sortOrder}
                    rowSize="fit"
                    onSort={onSort}
                    onDelete={onDelete}
                    bottomContent={editAccess && (
                        <Button
                            variant="success"
                            onClick={() => dispatch(addModal({
                                key: "addParent",
                                content: <NotAssignedParents requirement={requirement} />,
                            }))}
                        >
                            {lang.add}
                        </Button>
                    )}
                />
            </PageContent>
        </RequirementParentChildContentWrapper>
    )
}
export default Parents
